// extracted by mini-css-extract-plugin
export var errorsContainer = "_tb-1";
export var link = "_tb-0";